module.exports = __webpack_public_path__ + "static/media/construction.cede3a5c.svg";